/**
 * /frontend/src/features/analytics/constants/analyticsEndpoints.js
 */

import {
  ANALYTICS_ABANDONMENT_BY_SECTION,
  ANALYTICS_ABANDONMENT_SUMMARY,
  ANALYTICS_ABANDONMENT_TREND,
  ANALYTICS_APPOINTMENTS_BY_SERVICE,
  ANALYTICS_APPOINTMENTS_POPULAR_SLOTS,
  ANALYTICS_APPOINTMENTS_SUMMARY,
  ANALYTICS_APPOINTMENTS_TREND,
  ANALYTICS_ANOMALIES_ACTIVE,
  ANALYTICS_ANOMALIES_HISTORY,
  ANALYTICS_BOTTLENECK_SECTIONS,
  ANALYTICS_BOTTLENECK_ZONES,
  ANALYTICS_CUSTOMERS_BEHAVIOR,
  ANALYTICS_CUSTOMERS_SEGMENTS,
  ANALYTICS_CUSTOMERS_VISIT_TREND,
  ANALYTICS_OFFERS_BY_AUDIENCE,
  ANALYTICS_OFFERS_COMPARISON,
  ANALYTICS_OFFERS_FUNNEL,
  ANALYTICS_OFFERS_SUMMARY,
  ANALYTICS_PEAK_DAY_COMPARISON,
  ANALYTICS_PEAK_HEATMAP,
  ANALYTICS_PEAK_TOP_HOURS,
  ANALYTICS_QUEUE_PERFORMANCE,
  ANALYTICS_QUEUE_PERFORMANCE_TREND,
  ANALYTICS_STAFFING_EFFICIENCY,
  ANALYTICS_STAFFING_FORECAST,
  ANALYTICS_STAFFING_SCHEDULE_RECOMMENDATION,
  ANALYTICS_WHATIF_HOURS,
  ANALYTICS_WHATIF_SECTIONS,
  ANALYTICS_WHATIF_STAFF
} from '../../../shared/constants/endpoints';

/**
 * Central analytics endpoint map.
 */
export const ANALYTICS_ENDPOINTS = {
  QUEUE_PERFORMANCE: ANALYTICS_QUEUE_PERFORMANCE(''),
  QUEUE_PERFORMANCE_TREND: ANALYTICS_QUEUE_PERFORMANCE_TREND(''),

  PEAK_HEATMAP: ANALYTICS_PEAK_HEATMAP(''),
  PEAK_TOP_HOURS: ANALYTICS_PEAK_TOP_HOURS(''),
  PEAK_DAY_COMPARISON: ANALYTICS_PEAK_DAY_COMPARISON(''),

  ABANDONMENT_SUMMARY: ANALYTICS_ABANDONMENT_SUMMARY(''),
  ABANDONMENT_BY_SECTION: ANALYTICS_ABANDONMENT_BY_SECTION(''),
  ABANDONMENT_TREND: ANALYTICS_ABANDONMENT_TREND(''),

  BOTTLENECK_SECTIONS: ANALYTICS_BOTTLENECK_SECTIONS(''),
  BOTTLENECK_ZONES: ANALYTICS_BOTTLENECK_ZONES(''),

  OFFERS_SUMMARY: ANALYTICS_OFFERS_SUMMARY(''),
  OFFERS_FUNNEL: (offerId) => ANALYTICS_OFFERS_FUNNEL(offerId),
  OFFERS_COMPARISON: ANALYTICS_OFFERS_COMPARISON(''),
  OFFERS_BY_AUDIENCE: ANALYTICS_OFFERS_BY_AUDIENCE(''),

  APPOINTMENTS_SUMMARY: ANALYTICS_APPOINTMENTS_SUMMARY(''),
  APPOINTMENTS_TREND: ANALYTICS_APPOINTMENTS_TREND(''),
  APPOINTMENTS_POPULAR_SLOTS: ANALYTICS_APPOINTMENTS_POPULAR_SLOTS(''),
  APPOINTMENTS_BY_SERVICE: ANALYTICS_APPOINTMENTS_BY_SERVICE(''),

  CUSTOMERS_BEHAVIOR: ANALYTICS_CUSTOMERS_BEHAVIOR(''),
  CUSTOMERS_SEGMENTS: ANALYTICS_CUSTOMERS_SEGMENTS(''),
  CUSTOMERS_VISIT_TREND: ANALYTICS_CUSTOMERS_VISIT_TREND(''),

  STAFFING_FORECAST: ANALYTICS_STAFFING_FORECAST(''),
  STAFFING_EFFICIENCY: ANALYTICS_STAFFING_EFFICIENCY(''),
  STAFFING_SCHEDULE_RECOMMENDATION: ANALYTICS_STAFFING_SCHEDULE_RECOMMENDATION(''),

  WHATIF_SECTIONS: ANALYTICS_WHATIF_SECTIONS(''),
  WHATIF_STAFF: ANALYTICS_WHATIF_STAFF(''),
  WHATIF_HOURS: ANALYTICS_WHATIF_HOURS(''),

  ANOMALIES_ACTIVE: ANALYTICS_ANOMALIES_ACTIVE(''),
  ANOMALIES_HISTORY: ANALYTICS_ANOMALIES_HISTORY('')
};
